/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import * as React from 'react'
import Grid from '@material-ui/core/Grid'
import { IHealthAndSafetyField, IHSCustomField } from '../../../models/HSFields'
import { IHelpInfo } from '../../../models/CustomFields'
import { mapIDAndNameOptions } from '../../../utils/incident/hsLists'
import HSField from './HSField'
import {
  IOneplaceLibraryContextProp,
  withOneplaceLibraryContext
} from '../../OneplaceLibraryProvider'
import { ISelectionLists } from '../../form_controls/types'

export interface IHSCustomFieldsGroupProps extends IOneplaceLibraryContextProp {
  label: string
  fields: IHSCustomField[]
  helpInfos: IHelpInfo[]
  tab: 'details' | 'investigation'
  onFieldChanged(field: IHSCustomField): void
}

export const HSCustomFieldsGroup = withOneplaceLibraryContext(
  (props: IHSCustomFieldsGroupProps) => {
    const fields = props.fields.filter(
      (field) =>
        (props.tab == 'details' && field.incidentDetailTab) ||
        (props.tab == 'investigation' && !field.incidentDetailTab)
    )

    if (fields.length == 0) {
      return null
    }
    return (
      <Grid container spacing={2} style={{ marginBottom: 16 }}>
        {fields.map((field) => (
          <HSCustomField
            key={field.customFieldId}
            field={field}
            helpInfos={props.helpInfos}
            onFieldChanged={props.onFieldChanged}
          />
        ))}
      </Grid>
    )
  }
)

export interface IHSCustomFieldProps extends IOneplaceLibraryContextProp {
  field: IHSCustomField
  helpInfos: IHelpInfo[]
  onFieldChanged(field: IHSCustomField): void
}

export interface IHSCustomFieldState {
  customFieldId: string
  field: IHSCustomField
  values: { [customFieldId: string]: any }
  fieldMeta: IHealthAndSafetyField
  selectionLists: ISelectionLists
}

/**
 * <HSCustomField /> is a wrapper around <HSField /> which maps the CustomField JSON structure
 * to the props expected by <HSField />
 */
export const HSCustomField = withOneplaceLibraryContext(
  // eslint-disable-next-line react/display-name
  class extends React.Component<IHSCustomFieldProps, IHSCustomFieldState> {
    constructor(props: any) {
      super(props)
      const { field } = this.props
      // TODO: These will need to update if the passed field changes
      const selectionLists: ISelectionLists = {}
      if (field.allOptionsList && field.allOptionsList.length) {
        selectionLists.options = mapIDAndNameOptions(field.allOptionsList)
      }
      const customFieldId = String(field.customFieldId)
      const fieldMeta: IHealthAndSafetyField = {
        name: customFieldId,
        type: field.type,
        label: field.name,
        mandatory: field.mandatory,
        selectMany: field.selectMany,
        selectionList: 'options',
        templateData: field.templateData,
        dateFormat: field.dateFormat,
        dateTimeFormat: field.dateTimeFormat,
        timeFormat: field.timeFormat,
        bgColor: field.bgColor,
        markdownData: field.markdownData
      }

      const values = { [customFieldId]: this.apiValueToFieldValue(field) }
      this.state = {
        customFieldId,
        field,
        fieldMeta,
        values,
        selectionLists
      }
    }

    apiValueToFieldValue(field: IHSCustomField) {
      if (this.props.field.type == 'SELECT') {
        if (field.selectMany) {
          return field.selectedOptionsList
        } else {
          return field.selectedOptionsList.length > 0
            ? field.selectedOptionsList[0]
            : null
        }
      } else if (this.props.field.type == 'DATE') {
        const dt = field.value
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        if (dt && dt.slice(2, 3) == '-') {
          // API Custom Field Date format is DD-MM-YYYY
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
          return `${dt.slice(6, 10)}-${dt.slice(3, 5)}-${dt.slice(0, 2)}`
        } else {
          return dt
        }
      } else if (this.props.field.type == 'BOOLEAN') {
        // could be string or boolean, we check both of them
        return field.value == true || field.value == 'true'
      } else if (this.props.field.type == 'PHOTO') {
        return field.imgData
      }
      return field.value
    }

    fieldValueToApiValue(fieldValue: any) {
      const updatedField: IHSCustomField = { ...this.props.field }
      if (this.props.field.type == 'SELECT') {
        if (updatedField.selectMany) {
          updatedField.selectedOptionsList = fieldValue
        } else {
          updatedField.selectedOptionsList = fieldValue ? [fieldValue] : []
        }
      } else if (this.props.field.type == 'PHOTO') {
        updatedField.imgData = fieldValue
      } else {
        updatedField.value = fieldValue
      }
      return updatedField
    }

    onFieldChanged = (values: { [fieldName: string]: any }) => {
      const { customFieldId } = this.state
      const value = values[customFieldId]
      const updatedField = this.fieldValueToApiValue(value)

      this.setState({ values })
      this.props.onFieldChanged(updatedField)
    }

    render() {
      const { fieldMeta, values, selectionLists } = this.state

      return (
        <HSField
          key={fieldMeta.name}
          field={fieldMeta}
          selectionLists={selectionLists}
          values={values}
          helpInfos={this.props.helpInfos}
          onFieldsChanged={this.onFieldChanged}
          addSpacing={true}
        />
      )
    }
  }
)
